import { useAppSelector } from '@redux/hooks';
import { getSeoAnnotation } from '@entities/Seo';
import classNames from 'classnames';

import styles from './seoDescriptionBlock.module.scss';

export const SeoDescriptionBlock = ({ className }: { className?: string }) => {
  const annotation = useAppSelector(getSeoAnnotation);

  if (!annotation && !annotation?.length) {
    return null;
  }

  if (Array.isArray(annotation) && annotation?.length) {
    return (
      <div className={classNames(styles.WrapperAnnotation, styles.isArray, className)}>
        {annotation.map((block, index) => (
          <div key={index} className={styles.WrapperBlock} dangerouslySetInnerHTML={{ __html: block }} />
        ))}
      </div>
    );
  }

  return (
    <div className={classNames(styles.WrapperAnnotation, className)}>
      <div dangerouslySetInnerHTML={{ __html: annotation }} />
    </div>
  );
};
